module.exports = __webpack_public_path__ + "img/empty_production.3f6b8a82.png";